import { render, staticRenderFns } from "./tinkList.vue?vue&type=template&id=87a407e8"
import script from "./tinkList.vue?vue&type=script&lang=js"
export * from "./tinkList.vue?vue&type=script&lang=js"
import style0 from "./tinkList.vue?vue&type=style&index=0&id=87a407e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports